import { createElement } from 'react';
import { _ as __assign } from '../../tslib.es6-c3225972.js';
import { a9 as LinkPrimaryNav$1 } from '../../index.esm-ade4952b.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var styles = {"link-primary-nav__uq-label":"uq-ec-link-primary-nav__uq-label","linkPrimaryNavUqLabel":"uq-ec-link-primary-nav__uq-label","fr-ec-label":"uq-ec-fr-ec-label","frEcLabel":"uq-ec-fr-ec-label"};

var LinkPrimaryNav = function LinkPrimaryNav(props) {
  return /*#__PURE__*/createElement(LinkPrimaryNav$1, __assign({}, props, {
    className: styles.linkPrimaryNavUqLabel
  }));
};
LinkPrimaryNav.displayName = 'LinkPrimaryNav';

export { LinkPrimaryNav };
